/**
 * Highlights whose delete the host has not answered yet, shared by every surface that
 * can delete one: the selection tool and the notebook menus are mounted together, so
 * the same highlight can be confirmed from both while the first request is in flight.
 * A confirmation for a highlight already on its way out is ignored, so the host gets
 * one delete and the list is edited once. Kept per highlight so a slower delete
 * settling later does not release a newer one.
 */
const pendingUuids = new Set();

export const pendingHighlightDeletes = {
    has: uuid => pendingUuids.has(uuid),
    add: uuid => {
        pendingUuids.add(uuid);
    },
    release: uuid => {
        pendingUuids.delete(uuid);
    },
};
